import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/category', label: '设备分类' },
    { path: '/about', label: '关于我们' },
  ];

  const bgClass = scrolled
    ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
    : 'bg-transparent';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-drop-fill text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-lg font-semibold text-foreground-900">
              喷水系统专业方案
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="whitespace-nowrap cursor-pointer px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
            >
              联系我们
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="whitespace-nowrap cursor-pointer px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors duration-200"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}